import { render, staticRenderFns } from "./FormDenunciationsQuestions.vue?vue&type=template&id=ad8fbfec&scoped=true&"
import script from "./FormDenunciationsQuestions.vue?vue&type=script&lang=js&"
export * from "./FormDenunciationsQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FormDenunciationsQuestions.vue?vue&type=style&index=0&id=ad8fbfec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8fbfec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VFileInput,VForm,VRow,VTextField,VTextarea})
